import angular from 'angular';
import ActionGuideConst from '../constants/action-guide';
import AnalyticsServ from './analytics';

class ActionGuideServ {
  constructor(ActionGuide, AnalyticsServ, $rootScope) {
    this.analytics = analytics;
    this.rootScope = $rootScope;
    this.success = this.success.bind(this)
    this.reset = () => {
      this.rootScope.guideEnabled = false;
      this.guides = ActionGuide.guides;
      this.steps = angular.copy(ActionGuide.steps);
      this.activeGuide = null;
      this.activeStep = null;
      this.activeIndex = null;
      this.unbinders = [];
      this.contexts = {};
    }
    this.reset()
    this.anchors = {
      element: {
        pos: {
          left: this.xy(-1, 0),
          right: this.xy(0, 0),
          top: this.xy(0, -1),
          bottom: this.xy(0, 0),
          center: this.xy(-0.5, -0.5)
        },
        align: {
          left: this.xy(0, 0),
          right: this.xy(-1, 0),
          top: this.xy(0, 0),
          bottom: this.xy(0, -1),
          center: this.xy(-0.5, -0.5)
        }
      },
      source: {
        left: this.xy(0, 0),
        right: this.xy(1, 0),
        top: this.xy(0, 0),
        bottom: this.xy(0, 1),
        center: this.xy(0.5, 0.5)
      }
    }
  }
  xy(left, top) {
    return { left, top }
  }
  getCoordinates(elem, target, location) {
    let [pos, align] = location.split('-')
      // elem and target $() elems, location 'top-left'
    let anchors = this.anchors
    let { top: offsetTop, left: offsetLeft } = target.getBoundingClientRect()
    let top = offsetTop +
      (target.scrollHeight *
        (anchors.source[pos].top + anchors.source[align].top)) +
      (elem.scrollHeight *
        (anchors.element.pos[pos].top + anchors.element.align[align].top));
    let left = offsetLeft +
      (target.scrollWidth *
        (anchors.source[pos].left + anchors.source[align].left)) +
      (elem.scrollWidth *
        (anchors.element.pos[pos].left + anchors.element.align[align].left));
    return { top: `${top}px`, left: `${left}px` };
  }

  success() {
    if (this.activeStep) {
      this.activeStep.complete = true;
    }
    if (this.activeStep.skipComplete) {
      this.nextStep()
    }
  }
  watch() {
    var targetConext = this.contexts[this.activeStep.context];
    if (!targetConext) {
      return
    }
    var target = targetConext(this.activeStep.watch.target)

    this.unbinders.push(() => {
      target.removeEventListener(this.activeStep.watch.event, this.success)
    })
    target.addEventListener(this.activeStep.watch.event, this.success);
  }
  attach() {
    var targetConext = this.contexts[this.activeStep.context];
    if (!targetConext) {
      return
    }
    var target = targetConext(this.activeStep.attach.target)
    var elem = targetConext('#action-guide-popover')

    this.activeStep.elementStyle = this.activeStep.manualPosition ?
      this.activeStep.elementStyle :
      this.getCoordinates(elem, target, this.activeStep.attach.location)
  }
  connect(context, contextualEval) {
    this.contexts[context] = contextualEval;
  }
  setGuide(key) {
    this.activeGuide = this.guides[key].map(step => this.steps[step]);
    this.setStep(this.activeIndex || 0);
    this.rootScope.guideEnabled = true;
  }
  setStep(index) {
    this.activeIndex = index;
    if (index <= this.activeGuide.length + 1) {
      this.activeStep = index === this.activeGuide.length ?
        this.steps['conclusion'] : index === this.activeGuide.length + 1 ?
        this.steps['close'] : this.activeGuide[this.activeIndex];
      this.watch()
      this.attach()
    } else {
      this.close()
    }
  }
  nextStep() {
    this.unbindWatchers()
    let index = this.activeIndex + 1;
    this.setStep(index)

  }
  finish() {
    // trigger hide warning
    this.setStep(this.activeGuide.length + 1)
    this.watch();
    this.attach();
  }
  close() {
    this.unbindWatchers()
    Object.keys(this.contexts).map(
      key => { this.contexts[key]('lf-action-guide').remove() })

    let completed = this.activeGuide.filter(step => step.complete).length;

    this.analytics.track('Guide Closed', {
      'Guide Completion Rate': completed / this.activeGuide.length
    })
    this.analytics.identify({
      'Guide Completed': (completed === this.activeGuide.length)
    })

    this.reset()
  }
  unbindWatchers() {
    this.unbinders.map(unbinder => unbinder())
    this.unbinders = [];
  }
}
ActionGuideServ.$inject = ['ActionGuide', 'AnalyticsServ', '$rootScope'];

export default angular.module('services.action-guide', [ActionGuideConst,
    AnalyticsServ
  ])
  .service('ActionGuideServ', ActionGuideServ)
  .name;



// WEBPACK FOOTER //
// ./project/services/action-guide.js